import React from 'react'
import { BottomSheetProps } from 'src/components/layout/MainLayout/MainBottomSheet/index'
import MainBottomSheetClosed from 'src/components/layout/MainLayout/MainBottomSheet/_components/MainBottomSheetClosed'
import { bottomInPageTransitionProps } from 'src/styles/animation'
import MainBottomSheetHeader from 'src/components/layout/MainLayout/MainBottomSheet/_components/MainBottomSheetHeader'
import { css } from 'styled-components'
import { Container } from 'src/components/common/Container'
import { layoutMaxSize, ZIndex } from 'src/styles/mixin'
import { Spinner } from 'src/components/common/Spinner'
import RenderIf from 'src/components/common/RenderIf'
import BackGroundDeem from 'src/components/common/BackgroundDeem'
import MainBottomSheetBody2 from 'src/components/layout/MainLayout/MainBottomSheet/_components/MainBottomSheetBody2'

const MainBottomSheetView = (props: BottomSheetProps) => {
  const { isBottomSheetOpen, isWalletCouponDataPending } = props

  return (
    <React.Fragment>
      {!isBottomSheetOpen ? (
        <MainBottomSheetClosed {...props} />
      ) : (
        <React.Fragment>
          <BackGroundDeem />
          <Container
            $option="flex_column"
            $style={S.MainBottomSheetOpenContainer()}
            {...bottomInPageTransitionProps}
          >
            <RenderIf when={isWalletCouponDataPending}>
              <Spinner />
            </RenderIf>
            <RenderIf when={!isWalletCouponDataPending}>
              <MainBottomSheetHeader {...props} />
              <MainBottomSheetBody2 {...props} />
            </RenderIf>
          </Container>
        </React.Fragment>
      )}
    </React.Fragment>
  )
}
export default MainBottomSheetView

const S = {
  MainBottomSheetOpenContainer: () => css`
    position: fixed;
    left: 0;
    right: 0;
    justify-content: space-between;
    bottom: 0;
    margin: auto;
    padding: 20px 0;
    min-width: 320px;
    height: 640px;
    z-index: ${ZIndex.BottomSheet};
    border-radius: 30px 30px 0 0;
    background: var(--black-100);
    ${layoutMaxSize};
  `,
}
